<template>
  <div class="top-container flex-column">
    <top-top v-if="viewList.length" :list="viewList" :pageStyle="pageStyle"></top-top>
    <top-nav v-if="navData.list && navData.list.length" :websiteId="website_id" :data="navData"></top-nav>
  </div>
</template>

<script>
  import topTop from "@/components/top-top";
  import topNav from "@/components/top-nav";
  import common from '@/assets/common'
  export default {
    name: 'top',
    components: {
      topTop,topNav
    },
    data() {
      return {
        viewList: [],
        pageStyle: {},
        website_id: '',
        navData: {}
      }
    },
    created() {
      this.website_id = this.$route.query.website_id
      this.getApi()
    },
    methods: {
      getApi() {
        this.$api.get('/api/web_list_temp/get_pc_temp',{
          params:{
            page_type: 2
          },
        }).then(res => {
          const data = res.data
          if(!data) return
          this.pageStyle = common.toPageStyle(data.pageStyle)
          this.viewList = data.viewList
        })
        this.$api.get('/api/web_list_temp/get_pc_temp',{
          params:{
            page_type: 3
          },
        }).then(res => {
          const data = res.data
          if(!data) return
          this.navData = data
        })
      },
    }
  }
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/layout/top.vue